import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

class Form extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            name: '',
            email: '',
            marketing: false,
            isDisabled: false,
            isLoading: false,
            recaptchaResponse: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if ( nextProps.isDisabled !== this.state.isDisabled ) {
            this.setState({ isDisabled: nextProps.isDisabled });
        }
    }

    handleInputChange = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ [name]: value });
    }

    handleSubmit = (e) => {
        e.preventDefault(); 

        this.setState({ 
            isDisabled: true,
            isLoading: true
        });

        if( this.state.recaptchaResponse ) {
            window.grecaptcha.reset();
        }
        
        this.captcha.execute();
    }

    handleRecaptchaChange = ( response ) => {
        // Recapcha resets itself sending a null response without user input 
        // after a period of time so prevent postback.
        if( !response ) return; 

        // Store response and trigger send method
        this.setState({ recaptchaResponse: response }, this.send );
    }    

    send() {        
        fetch( this.props.action, { 
            method: "POST", 
            body: JSON.stringify({
                competitionId: this.props.competitionId,
                name: this.state.name,
                email: this.state.email,
                marketing: this.state.marketing,
                recaptchaResponse: this.state.recaptchaResponse
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            this.props.onSubmit( data );
            this.setState({ isLoading: false });

            if( typeof this.props.isDisabled === 'undefined' ) {
                this.setState({ isDisabled: false });
            }
        });
    }

    render() {
        const className = this.props.className || '';
        const { isLoading, isDisabled } = this.state;

        return (
            <form className={ `SpinToWinForm ${ className }` } onSubmit={ this.handleSubmit }>
                <div className="SpinToWinForm-row">
                    <label className="SpinToWinForm-label" htmlFor="name">Your name:</label>
                    <input className="SpinToWinForm-input" id="name" type="text" name="name" onChange={this.handleInputChange} disabled={ isDisabled } required />
                </div>
                
                <div className="SpinToWinForm-row">
                    <label className="SpinToWinForm-label" htmlFor="email">Your email address:</label>
                    <input className="SpinToWinForm-input" id="email" type="email" name="email" onChange={this.handleInputChange} disabled={ isDisabled } required />
                </div>

                <div className="SpinToWinForm-row">
                    <div className="SpinToWinForm-checkbox">
                        <input id="marketing" type="checkbox" name="marketing" onChange={this.handleInputChange} disabled={ isDisabled } />
                        <label htmlFor="marketing">Tick this box if you wish to receive news and exclusive offers from Crew Clothing Company.</label>
                    </div>
                </div>

                <div className="SpinToWinForm-row">
                    <ReCAPTCHA ref={(el) => { this.captcha = el; }} sitekey={ this.props.recapchaKey } size="invisible" onChange={ this.handleRecaptchaChange } />
                </div>

                <button className={ `SpinToWinForm-button ${ isLoading ? 'is-loading' : '' }`} disabled={ isDisabled }>Click to Spin</button>
            </form>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js